var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { vnextExpAnalysisApi } from "../api.js";
import { TAGS } from "../common.js";
const vnextAnalysisApi = vnextExpAnalysisApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalysesByStepId: builder.query({
      query: (payload) => {
        return {
          url: `workspaces/${payload.workspaceId}/experimentsteps/${payload.query.stepId}/analyses`,
          body: void 0,
          method: "GET",
          params: __spreadProps(__spreadValues({}, payload), { "api-version": "1.0" })
        };
      },
      providesTags: (result, error, { query: { stepId } }) => [{ type: TAGS.VNEXT_ANALYSIS, id: stepId }]
    })
  })
});
const { usePrefetch: useVnextAnalysisApiPrefetch, useGetAnalysesByStepIdQuery } = vnextAnalysisApi;
export {
  useGetAnalysesByStepIdQuery,
  useVnextAnalysisApiPrefetch,
  vnextAnalysisApi
};
//# sourceMappingURL=analysis.js.map
